import Grid from '@mui/material/Grid';

import type {
  Contentful,
  FrontifyImageContent,
} from '@/contentful/contentful-exports';
import { getFrontifyBackgroundImageUrl } from '@/utils/frontify';

import useStyles from './HeroSmallTwoThirdsImage.styles';

export interface HeroSmallTwoThirdsImageContent extends Contentful {
  fields: {
    title: string;
    image: FrontifyImageContent[];
    imageAlignment: string;
  };
}

interface Props {
  content: HeroSmallTwoThirdsImageContent;
}

export default function HeroSmallTwoThirdsImage({ content }: Props) {
  const { image, title, imageAlignment } = content.fields;
  const imagePath = getFrontifyBackgroundImageUrl(image[0].preview_url, 1440);
  const { classes } = useStyles();

  return (
    <Grid
      container
      className={classes.heroContainer}
      style={{
        flexDirection: imageAlignment === 'left' ? 'row' : 'row-reverse',
      }}
    >
      <Grid
        className={classes.heroSection}
        style={{
          backgroundImage: imagePath,
        }}
        size={{
          lg: 8,
          xs: 12,
        }}
      />
      <Grid
        className={classes.heroTextContainer}
        size={{
          lg: 4,
          xs: 12,
        }}
      >
        <h1 className={classes.heroTitle}>{title}</h1>
      </Grid>
    </Grid>
  );
}
